import { RootState } from "../../../redux-store";
import { productDescriptionsKey } from ".";

// Stable empty reference so a key without suggestions doesn't churn selectors.
const NO_VALUES: string[] = [];

export const selectAutocompleteValues =
  (key: string) =>
  (state: RootState): string[] =>
    state.data.autocompleteSuggestions.fields[key] ?? NO_VALUES;

export const selectInvoiceLineDescriptions =
  (productId: string | null) =>
  (state: RootState): string[] =>
    state.data.autocompleteSuggestions.invoiceLineDescriptions[
      productDescriptionsKey(productId)
    ] ?? NO_VALUES;
